import { render, staticRenderFns } from "./UserSideMenu.vue?vue&type=template&id=2e5f566c&scoped=true&"
import script from "./UserSideMenu.vue?vue&type=script&lang=js&"
export * from "./UserSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserSideMenu.vue?vue&type=style&index=0&id=2e5f566c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f566c",
  null
  
)

export default component.exports